import { createInjectionKey } from "../../_utils/index.mjs";
export const buttonGroupInjectionKey = createInjectionKey('n-button-group');